var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-manager" }, [
    _c("div", { staticClass: "search-wrapper" }, [
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("类型:")]),
        _vm._v(" "),
        _c("div", { staticClass: "scroll-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "scroll",
              style: { width: 1.7 * _vm.s_jylx_list.length + "rem" },
            },
            _vm._l(_vm.s_jylx_list, function (item) {
              return _c(
                "span",
                {
                  class: ["radio", { check: _vm.s_jylx == item }],
                  on: {
                    click: function ($event) {
                      return _vm.selectRadio("s_jylx", item)
                    },
                  },
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("状态:")]),
        _vm._v(" "),
        _c("div", { staticClass: "scroll-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "scroll",
              style: { width: 1.7 * _vm.s_sfgk_list.length + "rem" },
            },
            _vm._l(_vm.s_sfgk_list, function (item) {
              return _c(
                "span",
                {
                  class: ["radio", { check: _vm.s_sfgk == item }],
                  on: {
                    click: function ($event) {
                      return _vm.selectRadio("s_sfgk", item)
                    },
                  },
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("公私:")]),
        _vm._v(" "),
        _c("div", { staticClass: "scroll-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "scroll",
              style: { width: 1.7 * _vm.s_gs_list.length + "rem" },
            },
            _vm._l(_vm.s_gs_list, function (item) {
              return _c(
                "span",
                {
                  class: ["radio", { check: _vm.s_gs == item }],
                  on: {
                    click: function ($event) {
                      return _vm.selectRadio("s_gs", item)
                    },
                  },
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("手机:")]),
        _vm._v(" "),
        _c("div", { staticClass: "input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.s_dh,
                expression: "s_dh",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.s_dh },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.s_dh = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("编号:")]),
        _vm._v(" "),
        _c("div", { staticClass: "input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.s_bh,
                expression: "s_bh",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.s_bh },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.s_bh = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-search", on: { click: _vm.search } }, [
        _vm._v("查询"),
      ]),
    ]),
    _vm._v(" "),
    _vm.showGenJinWrapper
      ? _c("div", { staticClass: "genjin-wrapper" }, [
          _c("div", { staticClass: "genjin-wrapper-inner" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.genjin,
                  expression: "genjin",
                },
              ],
              attrs: { placeholder: "请输入跟进信息" },
              domProps: { value: _vm.genjin },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.genjin = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "commit-genjin", on: { click: _vm.commitGenJin } },
              [_vm._v("提交")]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "list" },
      [
        _vm._l(_vm.list, function (item) {
          return _c(
            "li",
            {
              staticClass: "item",
              on: {
                click: function ($event) {
                  return _vm.goToDaKaGenJin(item)
                },
              },
            },
            [
              _c("span", { staticClass: "block" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("编号：")]),
                _vm._v(_vm._s(item.bh)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("状态：")]),
                _vm._v(_vm._s(item.status)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("交易类型：")]),
                _vm._v(_vm._s(item.jylx)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("客户名称：")]),
                _vm._v(_vm._s(item.name)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("公私：")]),
                _vm._v(_vm._s(item.sfgk)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("需求面积：")]),
                _vm._v(_vm._s(item.xqmj)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "block" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("需求房型：")]),
                _vm._v(_vm._s(item.jylx)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "block" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("录入日期：")]),
                _vm._v(_vm._s(item.add_time)),
              ]),
              _vm._v(" "),
              item.lxfs
                ? _c("span", { staticClass: "block" }, [
                    _c("span", { staticClass: "lable" }, [
                      _vm._v("联系业主："),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "btn-call",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.callPhone(item)
                          },
                        },
                      },
                      [_vm._v("查看电话")]
                    ),
                  ])
                : _vm._e(),
            ]
          )
        }),
        _vm._v(" "),
        _vm.hasMore
          ? _c("li", { staticClass: "next", on: { click: _vm.nextPage } }, [
              _vm._v("下一页"),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "list-null" }, [_vm._v(" 暂无数据 ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }